'use strict';
var Redux = require('redux');
var thunk = require('redux-thunk');

var AppReducer = require('../reducers/AppReducer');

var createStoreWithMiddleware = Redux.applyMiddleware(thunk)(Redux.createStore);

var configureStore = function (initialState) {
  return createStoreWithMiddleware(AppReducer, initialState);
};

module.exports = configureStore;



/** WEBPACK FOOTER **
 ** ./src/stores/AppStore.js
 **/